import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-0">
        {/* Section 1: Identity - 풀스크린 히어로 */}
        <section className="relative h-[50vh] md:h-[60vh] w-full flex items-center justify-center">
          <div className="absolute inset-0 w-full h-full">
            <img
              src="https://public.readdy.ai/ai/img_res/ca547ab7b3cd416589a6bb24d34655f4.jpg"
              alt="KW테크 정체성"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

          <div className="relative z-10 max-w-[1120px] mx-auto px-5 text-center">
            <h1 className="text-xl md:text-4xl font-bold text-white mb-4 md:mb-8 leading-[1.375] md:leading-[1.375]">
              전통의 지혜를 과학으로 증명하다<br />식물 영양의 새로운 기준 KW테크
            </h1>
            <p className="text-sm md:text-lg text-white/95 leading-relaxed max-w-3xl mx-auto">
              KW테크는 대한민국 전통 미생물 발효 공법을 현대 농업 과학에 접목한 기술 중심 기업입니다.
              <br className="hidden md:block" />
              단순한 비료 제조를 넘어 작물이 스스로 살아남을 수 있는 건강한 생태계를 설계합니다.
            </p>
          </div>
        </section>

        {/* Section 2: Technology */}
        <section className="py-16 md:py-32 bg-white">
          <div className="max-w-[1120px] mx-auto px-5">
            <div className="text-center mb-12 md:mb-20">
              <h2 className="text-xl md:text-4xl font-bold text-[#222222] mb-4 md:mb-6 leading-[1.375] md:leading-[1.375]">
                기다림의 미학 &lsquo;발효&rsquo;,<br />작물에게는 가장 빠른 혁신이 됩니다
              </h2>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
                전통 미생물 발효 공법을 현대화하여 영양소의 체내 흡수 매커니즘을 근본적으로 바꿨습니다.
              </p>
            </div>

            <div className="w-full aspect-[16/9] md:aspect-[21/9] rounded-2xl overflow-hidden shadow-xl mb-12 md:mb-20">
              <img
                src="https://readdy.ai/api/search-image?query=clean%20modern%20industrial%20manufacturing%20facility%20interior%20for%20raw%20material%20production%2C%20bright%20spacious%20factory%20floor%20with%20stainless%20steel%20processing%20equipment%20and%20conveyor%20systems%2C%20professional%20pharmaceutical%20grade%20production%20environment%20with%20natural%20lighting%20from%20large%20windows%2C%20organized%20warehouse%20with%20raw%20material%20storage%20tanks%20and%20quality%20control%20stations%2C%20pristine%20white%20walls%20and%20polished%20concrete%20floors%20showing%20advanced%20biotechnology%20manufacturing&width=1400&height=600&seq=abouttechfactory2024&orientation=landscape"
                alt="원료 생산 공장"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
              <div className="bg-[#f5f5f5] rounded-2xl p-6 md:p-8">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-emerald-600 rounded-full flex items-center justify-center mb-4 md:mb-5">
                  <i className="ri-flask-line text-white text-lg md:text-2xl"></i>
                </div>
                <h4 className="text-base md:text-xl font-bold text-[#222222] mb-2 md:mb-4">
                  전통 미생물 발효의 과학
                </h4>
                <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                  단순 혼합이 아닌, 자체 배양한 유익 미생물을 통해 장시간 숙성 과정을 거칩니다.
                </p>
              </div>

              <div className="bg-[#f5f5f5] rounded-2xl p-6 md:p-8">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-emerald-600 rounded-full flex items-center justify-center mb-4 md:mb-5">
                  <i className="ri-microscope-line text-white text-lg md:text-2xl"></i>
                </div>
                <h4 className="text-base md:text-xl font-bold text-[#222222] mb-2 md:mb-4">
                  나노 단위 이온화 공정
                </h4>
                <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                  발효 과정을 통해 거대 영양소 분자를 나노 단위의 미생물 대사산물로 쪼개어 이온화합니다.
                </p>
              </div>

              <div className="bg-[#f5f5f5] rounded-2xl p-6 md:p-8">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-emerald-600 rounded-full flex items-center justify-center mb-4 md:mb-5">
                  <i className="ri-flashlight-line text-white text-lg md:text-2xl"></i>
                </div>
                <h4 className="text-base md:text-xl font-bold text-[#222222] mb-2 md:mb-4">
                  에너지 손실 제로(Zero)
                </h4>
                <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                  이온화된 영양소는 식물이 흡수하기 위해 별도의 분해 과정을 거칠 필요가 없어,
                  스트레스 상황에서도 즉각적인 회복력을 제공합니다.
                </p>
              </div>

              <div className="bg-[#f5f5f5] rounded-2xl p-6 md:p-8">
                <div className="w-11 h-11 md:w-14 md:h-14 bg-emerald-600 rounded-full flex items-center justify-center mb-4 md:mb-5">
                  <i className="ri-shield-check-line text-white text-lg md:text-2xl"></i>
                </div>
                <h4 className="text-base md:text-xl font-bold text-[#222222] mb-2 md:mb-4">
                  입증된 안정성
                </h4>
                <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                  까다로운 골프장 잔디 관리 현장에서 검증된 기술력으로 기후 위기와 병해충으로부터 작물을 보호합니다.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3: Business */}
        <section className="py-16 md:py-32 bg-[#f5f5f5]">
          <div className="max-w-[1120px] mx-auto px-5">
            <h2 className="text-xl md:text-4xl font-bold text-[#222222] mb-8 md:mb-16 text-center leading-[1.375] md:leading-[1.375]">
              현장에서 입증된<br />KW테크의 전문 솔루션
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
                <div className="w-full h-48 md:h-64 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=golf%20ball%20resting%20perfectly%20on%20ultra%20dense%20thick%20green%20grass%20blades%2C%20close%20up%20shot%20showing%20excellent%20turf%20quality%20and%20blade%20density%2C%20professional%20golf%20course%20maintenance%20result%2C%20pristine%20healthy%20grass%20texture%20with%20golf%20ball%20in%20focus%2C%20premium%20golf%20course%20photography&width=600&height=400&seq=aboutbiz1&orientation=landscape"
                    alt="골프장 솔루션"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-8">
                  <h3 className="text-lg md:text-2xl font-bold text-[#222222] mb-2 md:mb-4">
                    골프장 솔루션
                  </h3>
                  <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                    국내 주요 컨트리클럽을 위한 17종 전용 라인업 및 정밀 관제 솔루션.
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
                <div className="w-full h-48 md:h-64 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=healthy%20ripe%20premium%20agricultural%20crops%20with%20abundant%20harvest%2C%20vibrant%20colorful%20fruits%20and%20vegetables%20showing%20excellent%20quality%20and%20yield%2C%20successful%20farming%20result%20with%20lush%20green%20leaves%20and%20perfect%20produce%2C%20professional%20agricultural%20photography%20showing%20high%20value%20crops&width=600&height=400&seq=aboutbiz2&orientation=landscape"
                    alt="프리미엄 농업"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-8">
                  <h3 className="text-lg md:text-2xl font-bold text-[#222222] mb-2 md:mb-4">
                    프리미엄 농업
                  </h3>
                  <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                    고부가가치 작물의 품질 향상과 수확량 증대를 위한 이온화 비료 공급.
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
                <div className="w-full h-48 md:h-64 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20agricultural%20research%20laboratory%20with%20precision%20analysis%20equipment%2C%20scientist%20working%20with%20high%20tech%20instruments%20for%20climate%20research%2C%20clean%20white%20lab%20environment%20with%20advanced%20biotechnology%20devices%2C%20professional%20scientific%20facility%20showing%20climate%20adaptation%20technology%20development&width=600&height=400&seq=aboutbiz3&orientation=landscape"
                    alt="기후 기술"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-8">
                  <h3 className="text-lg md:text-2xl font-bold text-[#222222] mb-2 md:mb-4">
                    기후 기술
                  </h3>
                  <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                    서리 피해 경감 및 동해 예방 등 기후 위기 대응 특수 제제 연구.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 4: Value */}
        <section className="py-16 md:py-32 bg-white">
          <div className="max-w-[1120px] mx-auto px-5">
            <h2 className="text-xl md:text-4xl font-bold text-[#222222] mb-8 md:mb-16 text-center leading-[1.375] md:leading-[1.375]">
              자연과 과학의 조화로 만드는<br />지속 가능한 내일
            </h2>

            <div className="flex flex-col md:grid md:grid-cols-2 md:gap-16 md:items-stretch">
              {/* Image – appears on top on mobile */}
              <div className="w-full rounded-2xl overflow-hidden shadow-xl h-56 md:h-auto mb-6 md:mb-0">
                <img
                  src="https://readdy.ai/api/search-image?query=fresh%20green%20leaves%20with%20morning%20dew%20drops%20in%20soft%20natural%20sunlight%2C%20close%20up%20macro%20photography%20of%20healthy%20vibrant%20plant%20foliage%20with%20crystal%20clear%20water%20droplets%2C%20serene%20peaceful%20nature%20scene%20representing%20sustainable%20agriculture%20and%20clean%20environment%2C%20bright%20emerald%20green%20tones%20with%20bokeh%20background&width=700&height=700&seq=aboutvalue2024v3&orientation=squarish"
                  alt="지속 가능한 미래"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>

              {/* Text – appears below on mobile */}
              <div className="flex flex-col justify-center">
                <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-6 md:mb-12">
                  KW테크의 지향점은 명확합니다. 토양 오염을 최소화하고 작물의 면역력을 근본적으로 높여,
                  어떤 환경 스트레스 속에서도 흔들리지 않는 최상의 컨디션을 유지하는 것입니다.
                </p>

                <div className="flex flex-col gap-5 md:gap-8">
                  <div className="flex items-start gap-4 md:gap-5">
                    <div className="w-11 h-11 md:w-14 md:h-14 min-w-[2.75rem] md:min-w-[3.5rem] bg-emerald-50 rounded-full flex items-center justify-center">
                      <i className="ri-leaf-line text-emerald-600 text-lg md:text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-base md:text-xl font-bold text-[#222222] mb-1 md:mb-2">
                        친환경
                      </h3>
                      <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                        토양에 남지 않고 완벽히 흡수되는 깨끗한 영양 공급
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 md:gap-5">
                    <div className="w-11 h-11 md:w-14 md:h-14 min-w-[2.75rem] md:min-w-[3.5rem] bg-emerald-50 rounded-full flex items-center justify-center">
                      <i className="ri-shield-check-line text-emerald-600 text-lg md:text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-base md:text-xl font-bold text-[#222222] mb-1 md:mb-2">
                        면역력 강화
                      </h3>
                      <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                        작물 스스로 환경 스트레스에 대응하는 근본적인 건강 증진
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 md:gap-5">
                    <div className="w-11 h-11 md:w-14 md:h-14 min-w-[2.75rem] md:min-w-[3.5rem] bg-emerald-50 rounded-full flex items-center justify-center">
                      <i className="ri-plant-line text-emerald-600 text-lg md:text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-base md:text-xl font-bold text-[#222222] mb-1 md:mb-2">
                        지속 가능성
                      </h3>
                      <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                        기후 변화 속에서도 안정적인 생육 환경 구축
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 5: Proof */}
        <section className="py-16 md:py-32 bg-[#f5f5f5]">
          <div className="max-w-[1120px] mx-auto px-5">
            <h2 className="text-xl md:text-4xl font-bold text-[#222222] mb-4 md:mb-8 text-center leading-[1.375] md:leading-[1.375]">
              기술로 맺은 파트너십<br />수치로 증명하는 공신력
            </h2>
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed text-center max-w-3xl mx-auto mb-8 md:mb-16">
              전국 주요 골프장 및 농업 파트너들이 KW테크를 선택하고 있습니다. 17종의 전문 제품 라인업과 보유한 특허 기술이 그 신뢰를 뒷받침합니다.
            </p>

            <div className="bg-white rounded-2xl p-6 md:p-12 shadow-lg">
              <h3 className="text-lg md:text-2xl font-bold text-[#222222] mb-5 md:mb-8 text-center">
                보유 인증 및 특허
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                <div className="aspect-square bg-gray-100 rounded-xl flex items-center justify-center">
                  <i className="ri-award-line text-4xl md:text-6xl text-gray-400"></i>
                </div>
                <div className="aspect-square bg-gray-100 rounded-xl flex items-center justify-center">
                  <i className="ri-medal-line text-4xl md:text-6xl text-gray-400"></i>
                </div>
                <div className="aspect-square bg-gray-100 rounded-xl flex items-center justify-center">
                  <i className="ri-file-shield-line text-4xl md:text-6xl text-gray-400"></i>
                </div>
                <div className="aspect-square bg-gray-100 rounded-xl flex items-center justify-center">
                  <i className="ri-verified-badge-line text-4xl md:text-6xl text-gray-400"></i>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}
